import { render, staticRenderFns } from "./BillAppointmentsList.vue?vue&type=template&id=0f4cb225&scoped=true"
import script from "./BillAppointmentsList.vue?vue&type=script&lang=js"
export * from "./BillAppointmentsList.vue?vue&type=script&lang=js"
import style0 from "./BillAppointmentsList.vue?vue&type=style&index=0&id=0f4cb225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4cb225",
  null
  
)

export default component.exports